export const formatPrice = (
  value: number,
  currency: string,
  options?: {
    signDisplay?: 'never' | 'always' | 'auto'
    minimumFractionDigits?: number
    maximumFractionDigits?: number
  }
) => {
  try {
    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      signDisplay: 'exceptZero',
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currency,
      ...options
    })

    return formatter.format(value).replaceAll(',', '.')
  } catch (error) {
    console.warn(`Invalid currency code: ${currency}. Falling back to 'USD'.`)

    const fallbackFormatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      signDisplay: 'exceptZero',
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currency: 'USD', // Default currency
      ...options
    })

    return fallbackFormatter.format(value).replaceAll(',', '.')
  }
}
